// "Appreciation" teaser strip for the Home page.
// Full curated wishlists live on /appreciation.
import { Link } from "react-router-dom";
import { ArrowRight, Gift } from "lucide-react";

const GIFT_IMAGE =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_trance-bookings/artifacts/zuhbz2fk_IMG_7498.jpg";

export default function TributeStrip() {
  return (
    <section
      data-testid="tribute-strip"
      className="relative py-24 md:py-32 border-y border-[#c9a04b]/20 bg-charcoal grain overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-16 grid md:grid-cols-12 gap-10 md:gap-14 items-center relative z-10">
        {/* Image */}
        <div className="md:col-span-5 order-2 md:order-1">
          <figure className="relative">
            <div className="absolute inset-0 -translate-x-3 -translate-y-3 border border-[#c9a04b]/35 pointer-events-none" />
            <div className="absolute inset-0 translate-x-3 translate-y-3 border border-[#c9a04b]/15 pointer-events-none" />
            <div className="relative aspect-[3/2] overflow-hidden border border-[#c9a04b]/25 bg-charcoalMuted">
              <img
                src={GIFT_IMAGE}
                alt="A curated arrangement of gifts - Chanel N°5, pearls, gold star, red heart, iPod, love-kiss gift bag"
                loading="lazy"
                className="w-full h-full object-cover"
              />
              <div
                aria-hidden="true"
                className="absolute inset-0 pointer-events-none"
                style={{ background: "linear-gradient(180deg, rgba(17,19,25,0) 55%, rgba(17,19,25,0.55) 100%)" }}
              />
            </div>
          </figure>
        </div>

        {/* Copy */}
        <div className="md:col-span-7 order-1 md:order-2">
          <div className="eyebrow mb-5">A Gift for Cleopatra</div>
          <h2 className="font-serif text-4xl md:text-5xl text-cream leading-tight mb-5">
            Tokens of <em className="text-gold">appreciation</em>.
          </h2>
          <p className="text-cream/70 text-sm md:text-base leading-relaxed max-w-xl mb-10">
            If a session has moved you, or if you simply enjoy the pleasure of giving -
            a curated collection of wishlists is kept here. Nothing is expected;
            everything is remembered.
          </p>

          <Link
            to="/appreciation"
            data-testid="tribute-page-cta"
            className="btn-primary inline-flex items-center"
          >
            <Gift size={14} className="mr-2" />
            View Appreciation
            <ArrowRight size={14} className="ml-2" />
          </Link>

          <p className="mt-6 text-[11px] uppercase tracking-[0.22em] text-cream/40">
            Adults 18+ · Tributes are never a substitute for booking.
          </p>
        </div>
      </div>
    </section>
  );
}
